<template>
    <div id="app">
        <Loading v-if="mainLoading"/>
        <Admin v-else-if="isLoggedIn"/>
        <Login v-else/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {MAIN_LOADING} from '@/store';
    import Loading from '@/views/Loading';
    import Login from '@/views/Login';
    import Admin from '@/views/Admin';

    export default {
        components: {
            Loading,
            Login,
            Admin
        },
        computed: {
            ...mapState(['mainLoading', 'isLoggedIn'])
        },
        created() {
            this.$store.commit(MAIN_LOADING, true);
            this.$store.dispatch('initProfile', true);
        }
    }
</script>

<style>
</style>
